import { render } from "./posPrintSet.vue?vue&type=template&id=b48908e4"
import script from "./posPrintSet.vue?vue&type=script&lang=js"
export * from "./posPrintSet.vue?vue&type=script&lang=js"

import "./posPrintSet.vue?vue&type=style&index=0&id=b48908e4&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__